import React from "react";
import Turntable_Event_Description_card from "./Turntable_Event_Description_card/Turntable_Event_Description_card";
import Common_white_header from "../../Common/Common_Component/Common_white_header/Common_white_header";

function Turntable_Event_Description() {
  return (
    <>
      <section className="Turntable_Event_Description">
          <Common_white_header headingText={"Event Description"} />
        <div className="container">
          <Turntable_Event_Description_card />
        </div>
      </section>
    </>
  );
}

export default Turntable_Event_Description;
